<div class="mock-configurations-tab">
  <ix-mock-config-list></ix-mock-config-list>
</div>